module.exports = __webpack_public_path__ + "img/hr-train-wheels-6.06af9808.png";